import config from '../../../../config';
import { RegisterUserModel, UsersModel } from '../../../domainModels/users/UsersModel';
import { generateGuid } from '../../../helpers/guid';
import { axiosInstance as axios } from '../../axios/axiosInstance';

export const usersEndpoint = `${config.tachoAPI.url}/Users`;

export const getUsers = (): Promise<Array<UsersModel>> => {
    return axios
        .get<Array<UsersModel>>(usersEndpoint)
        .then(response => {
            return response.data.map(item => ({ ...item, frontId: generateGuid() }));
        })
        .catch(err => {
            throw Error(getUsers.name + err);
        });
};

export const registerUser = (newUser: RegisterUserModel): Promise<string> => {
    return axios
        .post<RegisterUserModel>(usersEndpoint, newUser)
        .then(response => {
            return newUser.email;
        })
        .catch(error => {
            throw Error(registerUser.name + error);
        });
};

export const updateUser = (user: UsersModel): Promise<UsersModel> => {
    return axios
        .patch<UsersModel>(`${usersEndpoint}/${user.id}`, user)
        .then(response => {
            return user;
        })
        .catch(error => {
            throw Error(updateUser.name + error);
        });
};

export const removeUser = (newEmail: string): Promise<string> => {
    return axios
        .delete<UsersModel>(`${usersEndpoint}/${newEmail}`)
        .then(response => {
            return newEmail;
        })
        .catch(error => {
            throw Error(removeUser.name + error);
        });
};

export const getUserRole = (): Promise<{ roleId: number }> => {
    return axios
        .get<{ roleId: number }>(`${usersEndpoint}/role`)
        .then(response => {
            return response.data;
        })
        .catch(err => {
            throw Error(getUserRole.name + err);
        });
};
